import React from 'react';
import buttons from '../css/buttons.module.scss';
import styles from '../css/siteFooter.module.scss';
import FooterLogo from '../media/logo-pivot-circle.svg';
import { PAGE_URLS } from '../utils/constants';
import { track } from '../utils/mixpanel-helper';
import { initHelpScoutWidget } from './help-scout-widget';
import Link from './link';

export const CURRENT_YEAR = new Date().getFullYear();

const SiteFooter = React.memo((): JSX.Element => {
  return (
    <footer className={styles.siteFooter}>
      <nav className={styles.nav}>
        <img
          src={FooterLogo}
          alt="www.pivot.co External link opens in a new tab"
          width="46"
          height="46"
        />
        <span className={styles.copyright}>
          &copy; Copyright {CURRENT_YEAR} Pivot Health Technologies Inc.
        </span>
        <Link to={PAGE_URLS.TERMS_AND_CONDITIONS} type="simple">
          Terms & Conditions
        </Link>
        <Link to={PAGE_URLS.PRIVACY_POLICY} type="simple">
          Privacy Policy
        </Link>
        <button
          className={buttons.simpleLink}
          onClick={() => {
            initHelpScoutWidget();
            track(`contact-us-footer-link`);
          }}
        >
          Contact Us
        </button>
      </nav>
    </footer>
  );
});

export default SiteFooter;
